import { render } from "./DefaultCoverManager.vue?vue&type=template&id=65a6a702"
import script from "./DefaultCoverManager.vue?vue&type=script&lang=js"
export * from "./DefaultCoverManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__